import { signOutreachDraft, type RedraftReason } from '../../services/taOutreachApi';
import type { OutreachCandidate } from '../../types/taOutreach';
import { ownerFirstName } from './ownerName';

/** Why a draft could not be put together from its stored parts and is written again (Oct 27 2026). */
export const REDRAFT_WHY: Record<RedraftReason, string> = {
  no_parts: 'this draft is older than the instant switch',
  no_brief: 'the role brief is missing',
  no_template: 'the template was not found',
  other_sender: 'it was written for another sender',
  missing_part: 'this template needs a part the draft does not have',
};

/** Why a colleague's draft could not be signed for the viewer (Oct 28 2026), as one short line. */
export const whyNotSigned = (reason?: string | null) =>
  reason && reason in REDRAFT_WHY ? REDRAFT_WHY[reason as RedraftReason] : 'it cannot be put together again';

/**
 * A colleague's draft put together for the viewer right before a send (Oct 28 2026): the new row,
 * or why it cannot be (then "Update" = Redraft). Never throws.
 */
export async function signForMe(id: string): Promise<{ item: OutreachCandidate } | { why: string }> {
  try {
    const r = await signOutreachDraft(id);
    return r.item ? { item: r.item } : { why: r.refusal || whyNotSigned(r.reason) };
  } catch (err) {
    return { why: err instanceof Error ? err.message : 'it could not be put together just now' };
  }
}

/**
 * A hand-edited draft put together for the viewer: whose edits were replaced (the writer, Sofia,
 * Oct 28 2026). Read off the row as it was BEFORE it was signed.
 */
export const editsReplacedBy = (before: OutreachCandidate) => ownerFirstName(before.draft?.writtenBy || before.owner) || 'The writer';
